import { useQuery } from "@apollo/client";
import { GET_REAL_ESTATE_PROJECT } from "@/graphql/queries/realestateProjects";
import { usePath } from "@/contexts/path/path";
import { getMaintainedParam } from "@/lib/apolloClient";
import { useAuthState } from "@/contexts/auth/auth.provider";

export default function useFindProject() {
  const { project } = usePath();
  const { user } = useAuthState();

  const maintainedParam = getMaintainedParam(user?.cooperative);

  const { data = {}, loading } = useQuery(GET_REAL_ESTATE_PROJECT, {
    skip: !project,
    variables: {
      project_id: parseInt(project?.id, 10),
      where: {
        project_id: { eq: parseInt(project?.id, 10) },
        published: { eq: 1 },
        ...maintainedParam,
      },
    },
  });
  const listings = data?.Search?.find?.projects?.listings || [];

  const proj = {
    ...project,
    ...data?.RealEstateProjects?.getProject,
  };
  return [
    {
      ...proj,
      totalUnits:
        (proj?.number_of_lands || 0) +
        (proj?.number_of_floors || 0) +
        (proj?.number_of_villas || 0) +
        (proj?.number_of_apartments || 0),
    },
    listings,
    loading,
  ];
}
